<ng-template #titleTemplate>
  {{ title }}
</ng-template>

<ng-template #descriptionTemplate>
  {{
    "AstroBin's equipment database is entirely maintained by the community. Feel free to make a contribution!"
      | translate
  }}
  <a class="learn-more" href="https://welcome.astrobin.com/features/equipment-database" target="_blank">
    {{ "Learn more" }}.
  </a>
</ng-template>

<ng-template #navTemplate>
  <astrobin-equipment-item-type-nav #itemTypeNavComponent></astrobin-equipment-item-type-nav>
</ng-template>

<div class="page">
  <ng-container *ngIf="breakpointMdMin">
    <h1><ng-container [ngTemplateOutlet]="titleTemplate"></ng-container></h1>
    <small><ng-container [ngTemplateOutlet]="descriptionTemplate"></ng-container></small>
  </ng-container>

  <div class="row g-0 g-3">
    <div *ngIf="breakpointMdMin" class="col-md-4 col-xl-3">
      <ng-container [ngTemplateOutlet]="navTemplate"></ng-container>
    </div>

    <div class="col-md-8 col-xl-9">
      <div *ngIf="contributors$ | async as contributors; else loading" class="row">
        <div *ngFor="let contributor of contributors" class="col-6 col-sm-4 col-lg-3">
          <div class="contributor">
            <img [alt]="contributor[3]" [src]="contributor[4]" class="avatar" />
            <div class="username">{{ contributor[3] }}</div>
            <div
              [ngbTooltip]="'Total number of edit proposals created or reviewed' | translate"
              class="badge badge-success"
            >
              {{ contributor[1] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
